import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Order, Language } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const ClientRefusalReasonCellContent: React.FC<
	ClientRefusalReasonCellContent.Props
> = ({ item, language }) => {
	const { t } = useTranslation();

	const content = useMemo(() => {
		const preparedCell =
			item?.cellsForTable?.[ColumnId.ClientRefusalReason];

		if (
			item?.cellsForTableSettings?.isCellsReady &&
			item?.cellsForTableSettings?.lang === language &&
			preparedCell != null
		) {
			return preparedCell;
		}

		return cellProcessing(item, language, t);
	}, [item, language, t]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ClientRefusalReasonCellContent {
	interface Props {
		item: Order.Model;
		language: Language;
	}
}

export default ClientRefusalReasonCellContent;
